import { useEffect, useState } from "react";
import usePhaseRedirect from "./usePhaseRedirect";

export default function IftarNoPhase() {
    usePhaseRedirect(); // redirects on mount based on current phase
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setTick(t => t + 1), 800);
    return () => clearInterval(interval);
  }, []);

  const dots = ".".repeat((tick % 3) + 1).padEnd(3, "\u00a0");

  return (
    <div style={{
      height: "100vh",
      background: "linear-gradient(180deg, #07111f 0%, #0a1628 60%, #061018 100%)",
      fontFamily: "'Segoe UI', system-ui, sans-serif",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      boxSizing: "border-box",
    }}>

      {/* Top Bar */}
      <div style={{
        flexShrink: 0,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 28px",
        borderBottom: "1px solid rgba(255,255,255,0.07)",
        background: "rgba(0,0,0,0.25)",
      }}>
        <span style={{
          fontSize: "clamp(10px, 1.2vw, 13px)",
          fontWeight: "600",
          letterSpacing: "3px",
          color: "rgba(255,255,255,0.4)",
          textTransform: "uppercase",
          display: "flex",
          alignItems: "center",
          gap: "6px",
        }}>
          <span style={{ color: "#e8c84a", fontSize: "15px" }}>●</span>
          ROUNDTABLE DISCUSSION
        </span>
        <span style={{
          fontSize: "clamp(10px, 1.2vw, 13px)",
          letterSpacing: "2px",
          color: "rgba(255,255,255,0.3)",
          textTransform: "uppercase",
        }}>Iftar Exchange 2026</span>
      </div>

      {/* Main Content */}
      <div style={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
      }}>

        {/* Faint banner background */}
        <img
          src="/dist/img/IftarExchangeBanner.png"
          alt=""
          style={{
            position: "absolute",
            inset: 0,
            width: "100%",
            height: "100%",
            objectFit: "contain",
            opacity: 0.08,
            pointerEvents: "none",
          }}
        />

        {/* Centered content */}
        <div style={{
          position: "relative",
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "32px",
          animation: "fadeIn 0.8s ease forwards",
        }}>

          {/* Spinner */}
          <div style={{ position: "relative", width: "92px", height: "92px" }}>
            <div style={{
              position: "absolute", inset: 0, borderRadius: "50%",
              border: "5px solid rgba(232,200,74,0.12)",
            }} />
            <div style={{
              position: "absolute", inset: 0, borderRadius: "50%",
              border: "2px solid transparent",
              borderTopColor: "#e8c84a",
              borderRightColor: "rgba(232,200,74,0.35)",
              animation: "spinCircle 1.2s linear infinite",
            }} />
            <div style={{
              position: "absolute",
              top: "50%", left: "50%",
              transform: "translate(-50%, -50%)",
              width: "7px", height: "7px",
              borderRadius: "50%",
              background: "#e8c84a",
              boxShadow: "0 0 10px rgba(232,200,74,0.8)",
            }} />
          </div>

          {/* Text */}
          <div style={{ textAlign: "center" }}>
            <p style={{
              margin: "0 0 10px",
              fontSize: "clamp(41px, 4.2vw, 52px)",
              fontWeight: "700",
              color: "rgba(255,255,255,0.92)",
              letterSpacing: "0.5px",
            }}>
              Phase 1 is about to begin
            </p>
            <p style={{
              margin: 0,
              fontSize: "clamp(21px, 2.2vw, 24px)",
              fontWeight: "600",
              letterSpacing: "3px",
              color: "rgba(255, 255, 255, 0.51)",
              textTransform: "uppercase",
            }}>
              Please stand by{dots}
            </p>
          </div>

          {/* Dot row */}
          <div style={{ display: "flex", gap: "6px" }}>
            {[0, 1, 2].map(i => (
              <div key={i} style={{
                width: "15px", height: "15px", borderRadius: "50%", gap: "20px",
                background: "rgba(232,200,74,0.6)",
                animation: `dotPulse 1.4s ease-in-out ${i * 0.2}s infinite`,
              }} />
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes spinCircle {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        @keyframes dotPulse {
          0%, 80%, 100% { opacity: 0.2; transform: scale(0.8); }
          40% { opacity: 1; transform: scale(1.2); }
        }
      `}</style>
    </div>
  );
}